const removeNull = (obj) => {
    Object.keys(obj).forEach((key) => {
        if (obj[key] && typeof obj[key] === 'object') {
            if (obj[key].length === 0) delete obj[key];
            else removeNull(obj[key]);
        } else if (obj[key] == null || obj[key] === '') delete obj[key]; // delete
    });
};

export default (object, path = null, toRemove = null, propsToRemove = null) => {
    if (path == null && toRemove == null) {
        removeNull(object);
    } else if (toRemove === true) {
        const keys = path.split('.');
        if (propsToRemove != null) {
            const props = propsToRemove.split(' ');
            props.forEach((prop) => {
                if (path === '') {
                    if (object != null && Object.prototype.hasOwnProperty.call(object, prop)) {
                        delete object[prop];
                    }
                } else {
                    if (
                        object[keys[0]] != null &&
            Object.prototype.hasOwnProperty.call(object[keys[0]], prop)
                    ) {
                        delete object[keys[0]][prop];
                    }
                }
            });
        } else {
            delete object[keys[0]];
        }
    }
};
